(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["get-the-look"] && !Shopify.designMode) return;
  try {
    (() => {
    const targets = document.querySelectorAll('[data-gtl-cards-target]:not([data-gtl-init])');

    targets.forEach((target) => {
      target.setAttribute('data-gtl-init', '');
      const url = target.getAttribute('data-gtl-url');
      if (!url) return;

      const trigger = target
        .closest('.get-the-look')
        ?.querySelector('button[command="show-modal"]');
      let pending = null;
      const skeleton = [...target.childNodes].map((node) => node.cloneNode(true));

      // "Could not load more. Try again." doubles as the retry button's label.
      const showError = () => {
        const wrapper = document.createElement('div');
        wrapper.setAttribute('role', 'alert');
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'btn btn-sm';
        retry.textContent = target.dataset.gtlErrorText || '';
        retry.addEventListener('click', () => {
          target.replaceChildren(...skeleton.map((node) => node.cloneNode(true)));
          target.setAttribute('aria-busy', 'true');
          load();
        });
        wrapper.append(retry);
        target.replaceChildren(wrapper);
      };

      const load = () => {
        if (pending) return pending;
        pending = fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const parsed = document.createElement('div');
            parsed.innerHTML = html;
            const cards = parsed.querySelector('[data-gtl-cards]');
            target.replaceChildren(...(cards ? [cards] : []));
            target.removeAttribute('aria-busy');
          })
          .catch((error) => {
            pending = null;
            showError();
            target.removeAttribute('aria-busy');
            console.error('Failed to load get-the-look products', error);
          });
        return pending;
      };

      if (trigger) {
        trigger.addEventListener('pointerenter', load, { once: true });
        trigger.addEventListener('touchstart', load, { once: true, passive: true });
        trigger.addEventListener('click', load);
      } else {
        load();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-countdown-timer"] && !Shopify.designMode) return;
  try {
    class ProductCountdownTimer {
    /**
     * @param {HTMLElement} element
     */
    constructor(element) {
      this.element = element;
      const endMsRaw = this.element.dataset.countdownEndMs;
      this.endMs = endMsRaw ? Number.parseInt(endMsRaw, 10) : Number.NaN;
      this.daysElement = this.element.querySelector('[data-unit="days"]');
      this.hoursElement = this.element.querySelector('[data-unit="hours"]');
      this.minutesElement = this.element.querySelector('[data-unit="minutes"]');
      this.secondsElement = this.element.querySelector('[data-unit="seconds"]');

      if (
        Number.isNaN(this.endMs) ||
        !this.daysElement ||
        !this.hoursElement ||
        !this.minutesElement ||
        !this.secondsElement
      ) {
        this.element.style.display = 'none';
        return;
      }

      this.updateTimer();
      this.intervalId = window.setInterval(() => this.updateTimer(), 1000);
      this.element.dataset.countdownInitialized = 'true';
    }

    destroy() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = undefined;
      }
    }

    updateTimer() {
      const now = Date.now();
      const timeLeft = this.endMs - now;

      if (timeLeft <= 0) {
        this.element.style.display = 'none';
        delete this.element.dataset.countdownInitialized;
        this.destroy();
        return;
      }

      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

      this.daysElement.textContent = String(days).padStart(2, '0');
      this.hoursElement.textContent = String(hours).padStart(2, '0');
      this.minutesElement.textContent = String(minutes).padStart(2, '0');
      this.secondsElement.textContent = String(seconds).padStart(2, '0');
    }
  }

  function initProductCountdownTimers(root = document) {
    root.querySelectorAll('.product-countdown-timer[data-countdown-end-ms]').forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      if (el.dataset.countdownInitialized === 'true') return;
      el._productCountdownTimer = new ProductCountdownTimer(el);
    });
  }

  function destroyProductCountdownTimers(root) {
    root.querySelectorAll('.product-countdown-timer').forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      const timer = el._productCountdownTimer;
      if (timer && typeof timer.destroy === 'function') {
        timer.destroy();
      }
      delete el._productCountdownTimer;
      delete el.dataset.countdownInitialized;
    });
  }

  document.addEventListener('DOMContentLoaded', () => initProductCountdownTimers());

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof HTMLElement) {
      initProductCountdownTimers(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target instanceof HTMLElement) {
      destroyProductCountdownTimers(event.target);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
